import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2ZM0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12Zm12.59-6.875c.631 0 1.396.107 2.063.531.71.453 1.192 1.191 1.337 2.203.139.972-.037 1.801-.426 2.479-.38.662-.925 1.116-1.435 1.423-.744.448-1.129 1.005-1.129 1.469V14a1 1 0 1 1-2 0v-.77c0-1.523 1.14-2.606 2.097-3.182.312-.189.57-.422.732-.706.154-.268.26-.643.181-1.2-.07-.49-.258-.688-.43-.798-.218-.139-.551-.219-.99-.219-.429 0-.867.076-1.213.16a6.324 6.324 0 0 0-.507.145l-.023.008h-.001L10.5 6.5l-.346-.938a1 1 0 0 0 .691 1.877M10.5 6.5c-.346-.938-.345-.938-.345-.939h.003l.004-.002.014-.005a3.597 3.597 0 0 1 .2-.067c.13-.04.313-.094.532-.147a7.321 7.321 0 0 1 1.681-.215M12 16a1 1 0 0 1 1 1v.5a1 1 0 1 1-2 0V17a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
